// 静态页面模拟图3
import * as React from 'react';

export default () => (
  <div>
    <h1>Shop Page</h1>
  </div>
);
